/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const privacyPolicyOrganisationInformationDataSchema = z.object({
	companyName: z.string().nullable(),
	streetAddress: z.string().nullable(),
	postalCode: z.string().nullable(),
	city: z.string().nullable(),
	country: z.string().nullable(),
	phoneNumber: z.string().nullable(),
	emailAddress: z.string().nullable(),
})

export type PrivacyPolicyOrganisationInformationDataSchema = z.infer<
	typeof privacyPolicyOrganisationInformationDataSchema
>
